export default __webpack_public_path__ + "static/media/Replace.37913886.svg";